import { render, staticRenderFns } from "./KpiReport.vue?vue&type=template&id=b7fbc8f6&scoped=true"
import script from "./KpiReport.vue?vue&type=script&lang=js"
export * from "./KpiReport.vue?vue&type=script&lang=js"
import style0 from "./KpiReport.vue?vue&type=style&index=0&id=b7fbc8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fbc8f6",
  null
  
)

export default component.exports